import { RootState } from '../store';

export const getTemplateLoadingState = (state: RootState) => state.editFlow.templateLoadingState;
export const getProjectCreationStatus = (state: RootState) => state.editFlow.projectCreationStatus;
export const getAdFromChat = (state: RootState) => state.editFlow.adFromChat;
export const getAdFromCreateTab = (state: RootState) => state.editFlow.adFromCreateTab;
export const getTemplateFromProject = (state: RootState) => state.editFlow.templateFromProject;
export const getRefetchCampaignAds = (state: RootState) =>
    state.editFlow.refetchData.refetchCampaignAds;
export const getRefetchProjects = (state: RootState) => state.editFlow.refetchData.refetchProjects;
